var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-autocomplete',{attrs:{"fetch-suggestions":_vm.searchUser,"placeholder":"输入昵称或手机号检索用户","clearable":""},on:{"select":_vm.handleUserSelect,"clear":_vm.initVerify},model:{value:(_vm.leaderName),callback:function ($$v) {_vm.leaderName=$$v},expression:"leaderName"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }